import EditIcon from "@/assets/icons/EditIcon";
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";
import { useState } from "react";
import FooterSocialLinksForm from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/Shared/FooterSocialLinksForm";
import { Paragraph } from "@/components/ui/Typography";

const SocialLinks = () => {
    const { templatePayload, updateTemplatePayload } = useMicroSiteContext();
        const isEdit = new URLSearchParams(window.location.search).get('action') === 'edit';

  const [isEditing, setIsEditing] = useState(false);

        const handleSave = (formData: { socialOne: string; socialTwo: string; socialThree: string; }) => {
          setIsEditing(false);
          const updatedPayload = {
            ...templatePayload,
            footerSection: {
              ...templatePayload.footerSection,
              ...formData
            },
        };
          updateTemplatePayload(updatedPayload);
        };

       

  const PreviewComponent = () => {
    return (
      <div className="flex relative w-full lg:py-4 gap-2  justify-end">   
          <div className="flex items-center gap-8" style={{color: templatePayload.branding.textColorCode}}>
          <div className="flex gap-8 flex-wrap">
            {templatePayload.footerSection.socialOne && <Paragraph>{templatePayload.footerSection.socialOne}</Paragraph>}

            {templatePayload.footerSection.socialTwo && <Paragraph>{templatePayload.footerSection.socialTwo}</Paragraph>}

            {templatePayload.footerSection.socialThree && <Paragraph>{templatePayload.footerSection.socialThree}</Paragraph>}
          </div>
          

{isEdit && <EditIcon  className="cursor-pointer" onClick={() => setIsEditing(true)} />}
          </div>
      
      </div>
    )
  };


  return (
    <div>
      {isEditing ? <FooterSocialLinksForm handleSave={handleSave} handleCancel={() => setIsEditing(false)} data={{
        socialOne: templatePayload.footerSection.socialOne || '',
        socialTwo: templatePayload.footerSection.socialTwo || '',
        socialThree: templatePayload.footerSection.socialThree || ''
      }} /> : <PreviewComponent />}
    </div>
  )
}

export default SocialLinks